const mutations = {
  setEnv (state, env) {
    state.env = { ...state.env, ...env };
  }
};

export default mutations;
